import Swiper, { Navigation, Pagination } from 'swiper';

export function initSwiper() {
  new Swiper('[data-swiper="testimonials"]', {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    spaceBetween: 24,
    grabCursor: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.swipe-next',
      prevEl: '.swipe-prev',
    },
    breakpoints: {
      768: {
        spaceBetween: 32,
      },
      992: {
        spaceBetween: 40,
      },
      1024: {
        spaceBetween: 60,
      },
    },
  });
}
